import { useMutation, useQueryClient } from '@tanstack/react-query';

import { AxiosError } from 'axios';

import {
  TPrototypeShortDto,
  TUpdatePrototypeDto,
  useAvApi,
} from '@app-velocity/av-api-v2';

export const useUpdateScenarioMutation = (
  workspaceId?: string,
  scenarioId?: string
) => {
  const { prototypes } = useAvApi();
  const queryClient = useQueryClient();

  return useMutation<
    TPrototypeShortDto | undefined,
    AxiosError,
    TUpdatePrototypeDto
  >({
    mutationKey: ['update-scenario-mutation'],
    mutationFn: async (body: TUpdatePrototypeDto) => {
      if (!workspaceId || !scenarioId) return;

      const res =
        await prototypes.putV2ProjectsPrototypesByProjectIdAndPrototypeId(
          body,
          {
            projectId: workspaceId,
            prototypeId: scenarioId,
          }
        );

      return res.data;
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['scenario', workspaceId, scenarioId],
      });
      queryClient.invalidateQueries({
        predicate: (query) =>
          Array.isArray(query.queryKey) &&
          query.queryKey.includes('workspace-prototypes') &&
          query.queryKey.includes(workspaceId),
      });
    },
  });
};
